import { BsMic } from 'react-icons/bs';

type AudioAnswer = {
  id: string;
  content: string | null;
  file_name?: string;
};

type AttachmentLike = {
  url: string;
};

const isRemoteUrl = (value?: string | null) => /^https?:\/\//.test(value || '');

export function AudioAnswerList({
  answers,
  attachments = [],
  fallbackName = 'Áudio',
}: {
  answers: Array<AudioAnswer>;
  attachments?: Array<AttachmentLike>;
  fallbackName?: string;
}) {
  const attachedUrls = new Set(attachments.map((a) => a?.url));
  const audios = (answers || []).flatMap((answer) => {
    const url = answer.content;
    if (!url || !isRemoteUrl(url) || attachedUrls.has(url)) return [];
    return [{ ...answer, url }];
  });

  if (audios.length <= 0) return <></>;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '0.5rem',
        flexWrap: 'wrap',
      }}
    >
      {audios.map((answer) => (
        <a
          key={answer.id}
          href={answer.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            padding: 4,
            borderRadius: 5,
            border: '1px solid #e2e8f0',
            fontSize: '0.85rem',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <BsMic />
            {answer.file_name || fallbackName}
          </div>
        </a>
      ))}
    </div>
  );
}
